const STEPS = [
    {
        n: "01",
        title: "Avaliação técnica",
        text: "Visitamos ou analisamos detalhes do seu sistema para definir o plano correto e o orçamento.",
    },
    {
        n: "02",
        title: "Plano de intervenção",
        text: "Definimos materiais, equipa e horário sem comprometer o funcionamento do seu negócio.",
    },
    {
        n: "03",
        title: "Limpeza técnica",
        text: "Desengorduramento profundo de hottes, condutas, motores e turbinas com produtos adequados.",
    },
    {
        n: "04",
        title: "Relatório & ficha técnica",
        text: "Entregamos relatório fotográfico antes/depois e ficha técnica da intervenção, com o intervalo ideal de manutenção.",
    },
];

const Process = () => {
    return (
        <section
            data-testid="process-section"
            className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-white border-y border-black/10"
        >
            <div className="max-w-7xl mx-auto">
                <div className="flex items-center gap-3 mb-6 reveal">
                    <span className="block w-12 h-px bg-[#9B2C2C]" />
                    <span className="label-tag" style={{ color: "#9B2C2C" }}>
                        Processo
                    </span>
                </div>
                <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-black uppercase tracking-tighter leading-[0.95] max-w-4xl mb-16 reveal text-[#0A0A0A]">
                    Como trabalhamos, do primeiro contacto à entrega.
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {STEPS.map((s, i) => (
                        <div
                            key={s.n}
                            data-testid={`process-step-${i}`}
                            className="relative reveal"
                        >
                            <div className="font-display text-7xl md:text-8xl font-black text-[#9B2C2C]/15 leading-none mb-4">
                                {s.n}
                            </div>
                            <div className="absolute top-2 left-0 w-12 h-px bg-[#2E7D5B]" />
                            <h3 className="font-display text-xl font-bold uppercase tracking-tight mb-3 text-[#0A0A0A]">
                                {s.title}
                            </h3>
                            <p className="text-[#0A0A0A]/55 text-sm leading-relaxed font-light">
                                {s.text}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Process;
